<template>
  <header class="header-nav">
    <div class="nav-container">
      <div class="nav-logo">
        <router-link to="/">
          <img src="@/assets/berts-logo-header.png" alt="BERT Points" class="logo-img" />
        </router-link>
      </div>
      
      <!-- Desktop Navigation -->
      <nav class="nav-menu desktop-menu">
        <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">
          Beranda
        </router-link>
        <router-link to="/komunitas" class="nav-link" :class="{ active: $route.path === '/komunitas' }">
          Komunitas Kami
        </router-link>
        <router-link to="/benefit" class="nav-link" :class="{ active: $route.path === '/benefit' }">
          Benefit BERT Points
        </router-link>
      </nav>
      
      <!-- Desktop Auth Button -->
      <div class="nav-auth desktop-auth">
        <bert-button variant="primary" size="md" @click="goToLogin">
          Masuk
        </bert-button>
      </div>
      
      <!-- Mobile Menu Button -->
      <div class="mobile-menu-button" @click="toggleMobileMenu">
        <div class="hamburger" :class="{ active: isMobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <div class="mobile-menu-overlay" :class="{ active: isMobileMenuOpen }" @click="closeMobileMenu">
      <div class="mobile-menu-content" @click.stop>
        <div class="mobile-menu-header">
          <button class="mobile-menu-close" @click="closeMobileMenu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="12" fill="var(--yellow-main)"/>
              <path d="M8 8L16 16M16 8L8 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        
        <nav class="mobile-nav-menu">
          <router-link 
            to="/" 
            class="mobile-nav-link" 
            :class="{ active: $route.path === '/' }"
            @click="closeMobileMenu"
          >
            Beranda
          </router-link>
          <router-link 
            to="/komunitas" 
            class="mobile-nav-link" 
            :class="{ active: $route.path === '/komunitas' }"
            @click="closeMobileMenu"
          >
            Komunitas Kami
          </router-link>
          <router-link 
            to="/benefit" 
            class="mobile-nav-link" 
            :class="{ active: $route.path === '/benefit' }"
            @click="closeMobileMenu"
          >
            Benefit BERT Points
          </router-link>
        </nav>
        
        <div class="mobile-auth">
          <bert-button 
            variant="primary" 
            size="lg" 
            :full-width="true"
            @click="goToLogin"
          >
            Masuk
          </bert-button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import BertButton from '../ui/Button.vue'

export default {
  name: 'AppHeader',
  components: {
    BertButton
  },
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('/login')
      this.closeMobileMenu()
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      // Prevent body scroll when menu is open
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
    }
  },
  beforeDestroy() {
    // Clean up body overflow when component is destroyed
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
/* Header Navigation */
.header-nav {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.nav-logo .logo-img {
  height: 40px;
  width: auto;
}

.nav-menu {
  display: flex;
  gap: var(--space-8);
}

.nav-link {
  text-decoration: none;
  color: var(--text-dark-grey);
  font-weight: var(--font-medium);
  font-size: var(--text-base);
  transition: color var(--transition-base);
  border-bottom: 2px solid transparent;
  padding-bottom: 4px;
}

.nav-link:hover,
.nav-link.active {
  color: var(--yellow-main);
  border-bottom-color: var(--yellow-main);
}

/* Mobile Menu Button */
.mobile-menu-button {
  display: none;
  cursor: pointer;
  padding: var(--space-2);
}

.hamburger {
  width: 40px;
  height: 40px;
  background: var(--yellow-main);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: all var(--transition-base);
}

.hamburger span {
  width: 20px;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all var(--transition-base);
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* Mobile Menu Overlay */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--blue-medium);
  z-index: 200;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-out;
}

.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-menu-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--space-6);
}

.mobile-menu-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--space-8);
}

.mobile-menu-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all var(--transition-base);
}

.mobile-menu-close:hover {
  transform: scale(1.05);
  opacity: 0.8;
}

.mobile-nav-menu {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin-bottom: auto;
}

.mobile-nav-link {
  background: white;
  color: var(--text-dark);
  text-decoration: none;
  padding: var(--space-5);
  border-radius: var(--radius-xl);
  font-size: var(--text-lg);
  font-weight: var(--font-medium);
  text-align: center;
  transition: all var(--transition-base);
}

.mobile-nav-link:hover,
.mobile-nav-link.active {
  background: var(--yellow-main);
  color: white;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.mobile-auth {
  margin-top: var(--space-8);
}

/* Responsive Design */
@media (max-width: 768px) {
  .nav-container {
    height: 70px;
    padding: 0 var(--space-4);
  }
  
  .nav-logo .logo-img {
    height: 35px;
  }
  
  .desktop-menu,
  .desktop-auth {
    display: none;
  }
  
  .mobile-menu-button {
    display: block;
  }
}

@media (min-width: 769px) {
  .mobile-menu-overlay {
    display: none;
  }
}
</style>